// TourModal.jsx
import React from 'react';
import styled from 'styled-components';
import { FaArrowLeft, FaArrowRight, FaTimes } from 'react-icons/fa';
import tourSteps from './tourSteps';

const TEAL = '#0f766e';
const TEAL_DARK = '#115e59';
const TEAL_LIGHT = '#f0fdfa';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
  padding: 16px;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
  max-width: 480px;
  width: 100%;
  overflow: hidden;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 12px 12px 0;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 18px;
  color: #999;
  cursor: pointer;
  padding: 4px;
  line-height: 1;
`;

const ModalBody = styled.div`
  padding: 0 32px 24px;
  text-align: center;
`;

const IconWrapper = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: ${TEAL_LIGHT};
  color: ${TEAL};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  margin: 0 auto 18px;
`;

const Titulo = styled.h3`
  margin: 0 0 12px;
  color: #134e4a;
  font-size: 19px;
`;

const Descricao = styled.p`
  margin: 0;
  color: #4b5563;
  font-size: 14px;
  line-height: 1.6;
  text-align: left;
`;

const Progresso = styled.div`
  display: flex;
  justify-content: center;
  gap: 6px;
  padding: 4px 0 20px;
`;

const Dot = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: ${props => (props.$ativo ? TEAL : '#d1d5db')};
  transition: background 0.2s;
`;

const Rodape = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-top: 1px solid #f0f0f0;
`;

const BotaoTexto = styled.button`
  background: none;
  border: none;
  color: #6b7280;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 8px;
`;

const BotaoPrimario = styled.button`
  background: ${props => (props.disabled ? '#9ca3af' : TEAL)};
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: ${props => (props.disabled ? '#9ca3af' : TEAL_DARK)};
  }
`;

const BotaoSecundario = styled.button`
  background: white;
  color: ${TEAL};
  border: 1.5px solid ${TEAL};
  border-radius: 6px;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const TourModal = ({ passoAtual, setPassoAtual, onFechar }) => {
  const passo = tourSteps[passoAtual];
  const Icone = passo.icone;
  const Exemplo = passo.Exemplo;
  const primeiroPasso = passoAtual === 0;
  const ultimoPasso = passoAtual === tourSteps.length - 1;

  const avancar = () => {
    if (ultimoPasso) {
      onFechar();
    } else {
      setPassoAtual(passoAtual + 1);
    }
  };

  const voltar = () => {
    if (!primeiroPasso) setPassoAtual(passoAtual - 1);
  };

  return (
    <ModalOverlay onClick={onFechar}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <CloseButton onClick={onFechar} title="Sair do tour">
            <FaTimes />
          </CloseButton>
        </ModalHeader>
        <ModalBody>
          <IconWrapper><Icone /></IconWrapper>
          <Titulo>{passo.titulo}</Titulo>
          <Descricao>{passo.descricao}</Descricao>
          {Exemplo && <Exemplo />}
        </ModalBody>
        <Progresso>
          {tourSteps.map((_, i) => (
            <Dot key={i} $ativo={i === passoAtual} />
          ))}
        </Progresso>
        <Rodape>
          <BotaoTexto onClick={onFechar}>Sair</BotaoTexto>
          <div style={{ display: 'flex', gap: '10px' }}>
            {!primeiroPasso && (
              <BotaoSecundario onClick={voltar}>
                <FaArrowLeft /> Voltar
              </BotaoSecundario>
            )}
            <BotaoPrimario onClick={avancar}>
              {ultimoPasso ? 'Concluir' : 'Avançar'} {!ultimoPasso && <FaArrowRight />}
            </BotaoPrimario>
          </div>
        </Rodape>
      </ModalContent>
    </ModalOverlay>
  );
};

export default TourModal;
